import React from 'react';
import * as XLSX from 'xlsx';
import { useDispatch } from 'react-redux';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import TopGroupBar from './TopGroupBar';
import SizeRangeGrading from './SizeRangeGrading';
import PomLibraryTable from './PomLibraryTable';
import GradingTable from './GradingTable';
import { useGradingGroupState } from './GradingGroupProvider';
import CustomButtonPopup from '../../../../Components/ModalPopup/CustomButtonPopup';
import ConfirmButtonPopup from '../../../../Components/ModalPopup/ConfirmButtonPopup';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import * as action from '../Store/Pom.action';
import Loader from '../../../../Components/Utility/Loader/Loader';

function GradingGroup() {
  const {
    handleSubmitData,
    gradingGroupState,
    setgradingGroup,
    id,
    GradingAddEditAccess,
    confirmGradingScopeChange,
    cancelGradingScopeChange,
  } = useGradingGroupState();
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const history = useHistory();

  const mapGradingForSheet = (dataToBeMapped) => {
    const array = [];
    const sizeRange = (gradingGroupState?.sizeRangesForHeader || []).map((val) => val?.sizeName);
    dataToBeMapped.forEach((val) => {
      const obj = {
        'POM Code*': val.code.trim(),
        'POM Description*': val.description.trim(),
      };
      const missingSizeNames = [];

      val.gradings.forEach((measure, key) => {
        if (measure.sizeName === '') {
          missingSizeNames.push(key);
        }
      });
      missingSizeNames.forEach((key) => {
        // eslint-disable-next-line no-param-reassign
        val.gradings[key].sizeName = sizeRange[key] || val.gradings[key].sizeName;
      });
      val.gradings.forEach((measure) => {
        obj[measure.sizeName] = measure && measure.grading !== '' ? measure.grading : '';
      });

      obj['Tol (-/+)'] = val.tolPlus;
      console.log('🚀 ~ dataToBeMapped.forEach ~ ecommSpec:', val);
      if (Object.keys(val).includes('ecommSpec')) {
        console.log('🚀 ~ dataToBeMapped.forEach ~ val:', val);
        obj['E-comm Spec'] = val?.ecommSpec?.name || '-';
      }

      array.push(obj);
    });

    return { data: array };
  };

  const downloadExcelSheet = () => {
    const updatedPomTable = gradingGroupState?.pomTableData?.map((item) => {
      const updatedGrading = item?.gradings?.map((gradingItem) => {
        if (gradingItem.isSampleSize === true || !gradingItem.grading) {
          return { ...gradingItem, grading: '0' };
        }
        return gradingItem;
      });

      return { ...item, gradings: updatedGrading };
    });

    const excelData = cloneDeep(updatedPomTable);
    const mappedData = mapGradingForSheet(excelData);
    console.log('mappedDatamappedData', mappedData);
    const ws = XLSX.utils.json_to_sheet(mappedData.data);
    ws['!cols'] = [{ wch: 20 }, { wch: 50 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'GradingSample.xlsx');
  };

  const handleToggle = () => {
    setgradingGroup((errState) => ({
      ...errState,
      showApplyConfirm: false,
    }));
  };

  const handleToggleButton = (e) => {
    setgradingGroup((prev) => ({
      ...prev,
      active: e,
    }));
  };

  const redirectToListPage = async () => {
    console.log('in fiffff');
    history.push('/libraries/gradings');
    await dispatch(action.clearGradingGroupReducer());
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <div className="mb-0">
            <div className="d-inline-flex align-items-center design-switch" style={{ height: 24 }}>
              <input
                type="checkbox"
                className="form-check-input comment-switch-input"
                id="customSwitch1"
                name="comment"
                checked={gradingGroupState?.active}
                onChange={(e) => handleToggleButton(e.target.checked)}
                disabled={!GradingAddEditAccess}
              />
            </div>
          </div>
          <h4 className="pom-title">
            {' '}
            {t('POMS.GRADING_GROUP.POM_GRADING_INDEX.GRADING_GROUP')} | {gradingGroupState?.groupName}
          </h4>
        </div>
        <div className="search-filter">
          <div className="floting-actions">
            {GradingAddEditAccess && (
              <CustomTooltip placement="top" tooltipText={t('POMS.GRADING_GROUP.POM_GRADING_INDEX.SAVES')}>
                <button aria-label="Save" type="button" name="Save" className="btn p-0" onClick={handleSubmitData}>
                  <i className="icon-Save-1" />
                </button>
              </CustomTooltip>
            )}
            {id && gradingGroupState?.pomTableData?.length > 0 && (
              <CustomTooltip placement="top" tooltipText={t('POMS.GRADING_GROUP.POM_GRADING_INDEX.EXPORT_EXCEL')}>
                <button type="button" aria-label="Save" name="Export excel" className="btn p-0" onClick={() => downloadExcelSheet()}>
                  <i className="icon-Export-Excel" />
                </button>
              </CustomTooltip>
            )}
          </div>
          <CustomTooltip tooltipText={t('POMS.GRADING_GROUP.POM_GRADING_INDEX.CANCEL')}>
            <button type="button" aria-label="Cancel" onClick={redirectToListPage} className="btn p-0" style={{ textDecoration: 'none' }}>
              <i className="icon-close f-20" />
            </button>
          </CustomTooltip>
        </div>
      </div>
      {gradingGroupState?.isLoading || gradingGroupState?.editModeLoading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : (
        <div>
          <TopGroupBar />
          <SizeRangeGrading />
          <PomLibraryTable />
          <GradingTable />
        </div>
      )}
      {gradingGroupState?.showApplyConfirm && (
        <CustomButtonPopup
          onOpen={gradingGroupState?.showApplyConfirm}
          title={t('POMS.GRADING_GROUP.POM_GRADING_INDEX.APPLY_SIZE')}
          message={t('POMS.GRADING_GROUP.POM_GRADING_INDEX.APPLY_SIZE_RANGE')}
          toggle={handleToggle}
        />
      )}
      {gradingGroupState?.showGradingScopeConfirm && (
        <ConfirmButtonPopup
          onOpen={gradingGroupState?.showGradingScopeConfirm}
          onConfirm={confirmGradingScopeChange}
          title={t('POMS.GRADING_GROUP.POM_GRADING_INDEX.GRADING_SCOPE_CHANGE_TITLE')}
          message={t('POMS.GRADING_GROUP.POM_GRADING_INDEX.GRADING_SCOPE_CHANGE_MESSAGE')}
          secondMessage={t('POMS.GRADING_GROUP.POM_GRADING_INDEX.GRADING_SCOPE_CHANGE_SECOND_MESSAGE')}
          toggle={cancelGradingScopeChange}
          onCancel={cancelGradingScopeChange}
          requireTypedConfirm
        />
      )}
    </>
  );
}

export default GradingGroup;
